<template>
  <div>
    <div class="tui-title" v-if="StatusName">审核状态：{{ StatusName }}</div>
    <div class="flex-center">
      <div class="tui-width">
        <el-form
          v-if="!IsData"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          label-position="left"
          class="demo-ruleForm"
        >
          <el-form-item label="名称" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="phone">
            <el-input v-model="ruleForm.phone" type="number"></el-input>
          </el-form-item>
          <el-form-item label="图片" prop="img">
            <more-picture
              :file-src="qualificationUrls"
              :file-id="qualificationIds"
              @setFileId="getFileArray($event)"
            />
          </el-form-item>
          <el-form-item label="介绍" prop="detail">
            <el-input
              v-model="ruleForm.detail"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item>
            <div class="flex-center">
              <el-button
                type="primary"
                class="tui-button"
                @click="onClickAdd('ruleForm')"
                >{{ StatusName == "已通过" ? "修 改" : "提 交" }}</el-button
              >
            </div>
          </el-form-item>
        </el-form>
        <el-form
          v-if="IsData"
          ref="ruleForm"
          :model="ruleForm"
          label-width="100px"
          label-position="left"
          class="demo-ruleForm"
        >
          <el-form-item label="名称">
            <div>{{ ruleForm.name }}</div>
          </el-form-item>
          <el-form-item label="联系方式">
            <div>{{ ruleForm.phone }}</div>
          </el-form-item>
          <el-form-item label="图片" prop="img">
            <div class="flex">
              <el-image
                v-for="(item, index) in qualificationUrls"
                :key="index"
                style="width: 100px; height: 100px; margin-right: 20px"
                :src="item"
                fit="contain"
              ></el-image>
            </div>
          </el-form-item>
          <el-form-item label="介绍">
            <div>{{ ruleForm.detail }}</div>
          </el-form-item>
          <el-form-item>
            <div class="flex-center">
              <el-button
                type="primary"
                class="tui-button"
                @click="IsData = false"
                >修 改</el-button
              >
            </div>
          </el-form-item>
        </el-form>
        <!-- <el-descriptions direction="vertical" :column="1" v-if="IsData">
          <el-descriptions-item label="名称">{{
            ruleForm.name
          }}</el-descriptions-item>
          <el-descriptions-item label="联系方式">{{
            ruleForm.phone
          }}</el-descriptions-item>
          <el-descriptions-item label="图片">
            <div class="flex">
              <el-image
                v-for="(item, index) in qualificationUrls"
                :key="index"
                style="width: 100px; height: 100px; margin-right: 20px"
                :src="item"
                fit="contain"
              ></el-image>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="介绍">
            <div style="color: #409eff">{{ ruleForm.detail }}</div>
          </el-descriptions-item>
          <el-descriptions-item label="状态">
            <div class="flex-center">
              <el-button
                type="primary"
                class="tui-button"
                @click="IsData = false"
                >修 改</el-button
              >
            </div>
          </el-descriptions-item>
        </el-descriptions> -->
      </div>
    </div>
  </div>
</template>

<script>
import morePicture from "../../components/morePicture.vue";
import { GetEP_MaskDetail, SaveEP_MaskInfo } from "../../api/api";

export default {
  components: {
    morePicture,
  },
  data() {
    return {
      ruleForm: {
        name: "",
        phone: "",
        detail: "",
        img: "",
        Id: 0,
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        phone: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
        detail: [{ required: true, message: "请输入介绍", trigger: "blur" }],
        img: [{ required: true, message: "请选择图片", trigger: "change" }],
      },
      qualificationUrls: [],
      qualificationIds: "",
      watchFlag: true,
      userInfo: {},
      StatusName: "",
      IsData: false,
    };
  },
  created() {
    this.userInfo = JSON.parse(
      window.localStorage.user ? window.localStorage.user : null
    );
    this.GetEP_MaskDetail();
  },
  methods: {
    async onClickAdd(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.ruleForm.img != "") {
            let res = await SaveEP_MaskInfo(this.ruleForm);
            if (res.data.success) {
              this.$message({
                type: "success",
                message: "成功",
              });
              this.GetEP_MaskDetail();
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          } else {
            this.$message({
              type: "error",
              message: "请上传图片",
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async GetEP_MaskDetail() {
      let res = await GetEP_MaskDetail({
        SysUserId: this.userInfo.uID,
      });
      if (res.data.success) {
        this.IsData = true;
        this.StatusName = res.data.response.StatusName;

        this.ruleForm = {
          name: res.data.response.Name,
          phone: res.data.response.Phone,
          detail: res.data.response.Detail,
          img: res.data.response.Img,
          Id: res.data.response.Id,
        };
        if (res.data.response.Img != "") {
          this.qualificationUrls = res.data.response.Img.split(",");
        }
        this.qualificationIds = res.data.response.Id + "";
      } else {
        this.IsData = false;
      }
    },
    getFileArray(e) {
      this.ruleForm.img = e;
    },
  },
};
</script>
<style lang="less" scoped>
.tui-title {
  font-size: 30px;
  font-weight: 600;
  padding: 20px;
}
.tui-width {
  width: 60%;
  margin: 20px auto;
}
.tui-button {
  width: 200px;
  margin: 0 auto;
}
</style>